import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import React from "react";
import StatusChip from "./StatusChip";
import type { SectionStatus } from "./sectionStatus";

type Props = {
  title: string;
  /** Absent for "Sobre la campaña" — its content lives in the wizard's step one,
   * which has no `missing` lines of its own to derive a status from. */
  status?: SectionStatus;
};

/** Same label styling as `@repo/components/src/ui/section-label`, but with room
 * for the Listo/Trabajando/Pendiente chip on the right — the mobile app's own
 * section labels have nothing to put there, so this stays local to the panel. */
const SectionHeader = React.memo(({ title, status }: Props) => (
  <HStack className="mb-2 ml-1 items-center justify-between">
    <Text
      bold
      size="2xs"
      className="uppercase tracking-widest text-typography-500"
    >
      {title}
    </Text>
    {status ? <StatusChip status={status} /> : null}
  </HStack>
));

SectionHeader.displayName = "SectionHeader";

export default SectionHeader;
